<template>
  <div class="login">
    <v-layout row justify-center>
      <v-flex xs12 sm6 md6 lg4>
        <v-card>
          <v-img
            src="https://storage.googleapis.com/spitzer-io/img/Logo%20Spitzer%20icone.png"
            aspect-ratio="3.50"
          ></v-img>
          <!-- <v-card-media class="backgroud-logo logo" height="200px">
          </v-card-media> -->
          <div class="backgroud-logo logo">
          </div>
          <v-card-title primary-title>
            <v-card-text>
              <p class="text-xs-center title primary--text">Redefinir senha</p>
              <v-form action="#" v-model="valid" ref="form" lazy-validation @submit.prevent="submit()">
                <v-text-field
                  label="E-Mail"
                  v-model="authentication.username"
                  :rules="[v => !!v || 'Você deve informar um número de telefone!']" required
                  disabled
                ></v-text-field>

                <v-text-field
                  class="password"
                  ref="password"
                  name="input-10-1"
                  label="Entre com sua senha"
                  hint="Deve conter mais de 6 caracteres"
                  v-model="authentication.password"
                  min="6"
                  :rules="[v => !!v || 'Você deve informar a senha!']" required
                  :append-icon="p1 ? 'visibility_off' : 'visibility'"
                  :append-icon-cb="() => (p1 = !p1)"
                  :type="p1 ? 'password' : 'text'"
                  counter
                  color="cyan darken"
                  loading
                >
                  <v-progress-linear v-if="custom" slot="progress" :value="progress" height="8" :color="color"></v-progress-linear>
                </v-text-field>

                <v-text-field
                  class="password"
                  type="password"
                  label="Confirme sua senha"
                  v-model="authentication.confpass"
                  :rules="[v => !!v || 'Você deve informar a senha!']" required
                ></v-text-field>

                <v-btn
                  color = 'primary'
                  block
                  :disabled="!valid"
                  @click="submit()"
                >
                  Alterar senha
                </v-btn>
                <br><hr><br>
                <router-link to="/patient/login">
                  <v-btn block >Login</v-btn>
                </router-link>

              </v-form>

            </v-card-text>
          </v-card-title>
          <v-card-actions>
            <div>
              <p>© 2017 - {{ new Date().getFullYear() }} <a href="http://www.spitzer.io">Spitzer.io</a> - Todos os direitos reservados</p>
              <p>Versão: {{getPkg.pkg.version}}</p>
            </div>
            <!-- <v-btn flat color="orange">Share</v-btn>
            <v-btn flat color="orange">Explore</v-btn> -->
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
    <v-snackbar
      :timeout="snackbarConfig.timeout"
      :color="snackbarConfig.color"
      :multi-line="snackbarConfig.mode === 'multi-line'"
      :vertical="snackbarConfig.mode === 'vertical'"
      v-model="snackbarConfig.snackbar"
    >
      {{ snackbarConfig.text }}
      <v-btn dark flat @click.native="snackbarConfig.snackbar = false">Fechar</v-btn>
    </v-snackbar>
  </div>
</template>


<script>
  import axios from 'axios'
  // import localforage from 'localforage'
  import { mapGetters } from 'vuex'

  export default {
    name: 'Reset-password',
    computed: {
      ...mapGetters({
        customer: 'customer',
        tokenRecoveryPassword: 'tokenRecoveryPassword'
      }),
      ...mapGetters('app', ['getTheme', 'getPkg']),
      progress () {
        return Math.min(100, this.authentication.password.length * 10)
      },
      color () {
        return ['error', 'warning', 'success'][Math.floor(this.progress / 40)]
      }
    },
    mounted () {
      this.jwtDecoded()
    },
    data: () => ({
      env: process.env.URL,
      snackbarConfig: {
        snackbar: false,
        color: 'error',
        mode: '',
        timeout: 6000,
        text: 'Erro de conexão com o servidor!'
      },
      valid: true,
      e1: true,
      p1: true,
      custom: true,
      authentication: {
        id: '',
        username: '',
        password: '',
        confpass: ''
      }
    }),
    methods: {
      async jwtDecoded () {
        const body = {
          id: this.authentication.id
        }
        const params = {
          params: {
            jwt: this.tokenRecoveryPassword,
            customer: this.customer
          }
        }
        await axios.post(process.env.URL + '/my-clinic-new/auth/get-recovery-token', body, params).then((response) => {
          this.authentication.username = response.data.decoded.username
          this.authentication.id = response.data.decoded.id
        }).catch((err) => {
          window.console.error(err)
          this.snackbarConfig.snackbar = true
          this.snackbarConfig.text = 'Token expirado!'
          return false
        })
      },
      changeCssColor () {
      },
      changeLogo () {
      },
      changeColorHTML () {
      },
      submit () {
        if (this.authentication.password !== this.authentication.confpass) {
          this.snackbarConfig.snackbar = true
          this.snackbarConfig.text = 'As senhas são divergentes!'
          return false
        }

        if (this.$refs.form.validate()) {
          axios.post(process.env.URL + '/my-clinic-new/auth/reset-password', {
            id: this.authentication.id,
            username: this.authentication.username,
            password: this.authentication.password
          }, {
            params: {
              customer: 'fsdafsad123123sd1f854fdf54d',
              token: this.tokenRecoveryPassword
            }
          }).then((response) => {
            this.$router.push('/patient/login')
          }).catch((err) => {
            if (err.response.data.message) {
              this.snackbarConfig.snackbar = true
              this.snackbarConfig.text = err.response.data.message
              return false
            }
            if (err.response.data.errors) {
              if (err.response.data.errors.username) {
                this.snackbarConfig.snackbar = true
                this.snackbarConfig.text = err.response.data.errors.username.msg
                return false
              }
              if (err.response.data.errors.password) {
                this.snackbarConfig.snackbar = true
                this.snackbarConfig.text = err.response.data.errors.username.password.msg
                return false
              }
            }
            this.snackbarConfig.snackbar = true
            this.snackbarConfig.text = err.response.data.result.error
          })
        }
      }
    }
  }
</script>





// WEBPACK FOOTER //
// src/views/auth/Reset-password.vue